@if (isEmptyLeerlingselectie() | async) {
	<app-button (clickit)="toggleDropdown()" buttonType="text-hover" [hovering]="showDropdown" [lowerHeight]="true">+ Leerlingselectie</app-button>
} @else {
	<div
		class="label"
		[class]="getClassNames()"
		[class.selected]="showDropdown"
		(click)="toggleDropdown()"
		[class.hilite]="hilite()"
		[class.ephemeral]="containsAdHoc() | async"
	>
		<span [title]="getTitle() | async" class="text-content-semi">{{ value | async }}</span>
		@if (isOptional()) {
			<app-icon name="sluiten" size="small" color="primary-1" hoverColor="secondary-1" (click)="removeFilter()"></app-icon>
		}
	</div>
}
@if (showDropdown) {
	<div class="dropdown-anchor">
		<div
			class="dropdown-border"
			[class.empty-leerlingselectie]="isEmptyLeerlingselectie() | async"
			(clickOutside)="showDropdown = false"
			[clickOutsideEvents]="'click,touchend'"
			[delayClickOutsideInit]="true"
		>
			<div class="dropdown-viewport">
				<div class="dropdown-content">
					@if (isDetailsList()) {
						<app-leerling-selectie-filter [detailsList]="true"></app-leerling-selectie-filter>
					} @else {
						<ng-template appFilterInput in-dropdown [filterName]="filterName"></ng-template>
					}
				</div>
			</div>
		</div>
	</div>
}
